import React from 'react'
import AboutPage from '../pages/AboutPage'

function About() {
  return (
    <AboutPage/>
  )
}

export default About